// FaqSection.tsx

import React from "react";
import Accordion from "./Accordion.tsx";
import DescriptionBox from "../../components/DescriptionBox/index.tsx";

const FaqSection = ({ heading, panels, searchValue = "" }: any) => {
  const filteredPanels = panels.filter((item: any) => {
    const labelMatch = item.label
      .toLowerCase()
      .includes(searchValue.toLowerCase());

    const contentMatch = item.content.some((c: any) =>
      Array.isArray(c)
        ? c.some((s) => s.toLowerCase().includes(searchValue.toLowerCase()))
        : String(c).toLowerCase().includes(searchValue.toLowerCase()),
    );

    return labelMatch || contentMatch;
  });

  return (
    <div>
      <div className="mb-6">
        <div
          className="
            mt-2
            flex
            flex-col
            md:flex-row
            md:items-end
            md:justify-between
            gap-4
          "
        >
          <DescriptionBox
            title="FAQ RESULTS"
            subTitle={heading}
            description="Explore curated answers and operational
              guidance."
          />
          <div
            className="
              rounded-full
              border
              border-[rgb(var(--border-primary))]
              bg-[rgb(var(--surface-2))]
              px-4
              py-2
              text-[12px]
              text-[rgb(var(--text-secondary))]
            "
          >
            {filteredPanels.length} Articles
          </div>
        </div>
      </div>

      <Accordion panels={filteredPanels} />
    </div>
  );
};

export default FaqSection;
